import React from "react";

const PlayerPlayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <defs>
        <clipPath id="clipPath5360150006">
          <path
            d="M0 0L32 0L32 32L0 32L0 0Z"
            fillRule="nonzero"
            transform="matrix(1 0 0 1 0 0)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath5360150006)">
        <path
          d="M1 1.43769L1 19.5627Q1 19.8381 1.1861 19.9592Q1.30422 20.0361 1.42481 19.9641L16.9177 10.6915Q16.9994 10.6426 16.9994 10.5002Q16.9994 10.3577 16.9179 10.309L1.42395 1.03574Q1.30422 0.964249 1.1861 1.04112Q1 1.16225 1 1.43769ZM-1 1.43769Q-1 0.788178 -0.700463 0.232795Q-0.409504 -0.306684 0.0951457 -0.635126Q0.617677 -0.975208 1.22758 -0.998427Q1.87702 -1.02315 2.45105 -0.680372L17.9446 8.59263Q18.4637 8.90312 18.7451 9.44584Q18.9994 9.93622 18.9994 10.5002Q18.9994 11.0642 18.7451 11.5545Q18.4637 12.0972 17.9448 12.4076L2.45019 21.6813Q1.87702 22.0235 1.22758 21.9988Q0.617676 21.9756 0.0951459 21.6355Q-0.409503 21.3071 -0.700463 20.7676Q-1 20.2122 -1 19.5627L-1 1.43769Z"
          fillRule="nonzero"
          transform="matrix(1 0 0 1 7 5.49981)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default PlayerPlayIcon;
